<template>
    <div class="app loginPageContainer">
        <div class="logoSection">
            <div class="weavrLogoContainer">
                <img src="img/brand/weavr.svg" height="100%" alt="Brand Logo Full" />
            </div>
        </div>
        <div class="container-fluid">
            <b-row class="hero-login-section ">
                <b-col md="6" class="left-img">
                    <div class="login-page-img">
                        <img src="img/loginPageLeftImg.png" width="100%" height="auto" class="img-fluid"
                            alt="Brand Logo Full" />
                    </div>
                </b-col>
                <b-col md="5" class="right-form">
                    <b-form @submit.prevent="login" class="login-form">
                        <div class="login-heading">
                            <h2 class="mainHeading">Welcome</h2>
                            <p class="subHeading">
                                Enter your credentials to access Weavr Account
                            </p>
                        </div>
                        <b-input-group class="input-group">
                            <label @input="flagError = false"
                                :class="{ danger: flagError, usernameinput: !flagError }">Email ID</label>
                            <input type="text" v-model="username" class="my-1" placeholder="Username"
                                autocomplete="username email" @input="flagError = false"
                                :class="{ danger: flagError, usernameinput: !flagError }" />
                        </b-input-group>
                        <b-input-group class="input-group">
                            <label @input="flagError = false"
                                :class="{ danger: flagError, usernameinput: !flagError }">Password</label>
                            <input type="password" v-model="password" class="my-1" placeholder="Password"
                                autocomplete="current-password" @input="flagError = false"
                                :class="{ danger: flagError, passwordinput: !flagError }" />
                            <div v-if="flagError" style="color: var(--red); font-size: 0.8rem" class="flagError ">
                                &#9888; Email ID or the password is incorrect, please try again.
                            </div>
                        </b-input-group>
                        <!-- <div class="remember-forgot-section">
    <div>
    <input type="checkbox" id="remember-me" name="remember-password" value="{{}}" />
    <label for="remember-me">Remember Me</label>
    </div>
    <a href="#">Forgot Password?</a>
    </div> -->
                        <b-button type="submit" class="btn primarycolor mt-2">Login</b-button>
                        <!-- <hr /> -->
                        <h4 class="redirect mt-3">Not registered yet? <span @click="$router.push('/register')">Sign
                                Up</span></h4>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data: function () {
        return {
            username: "",
            password: "",
            flagError: false,
            userAccess: {
                client: ""
            },

        };
    },
    methods: {
        processRedirect(userAccess) {
            let items = [];
            if (userAccess.client === 'amd') {
                items = [{
                    name: "Summary",
                    url: "/sov",
                    icon: "icon-chart",
                },
                {
                    name: "SOV Report",
                    url: "/sov-report",
                    icon: "icon-chart",
                },
                ];
            }
            if (userAccess.is_demo) {
                delete localStorage.demo_voc_product_list;
                delete localStorage.demo_itemCategory;
                delete localStorage.demo_selectedItemCategory;
                if (userAccess.philips)
                    items = [{
                        name: "Summary",
                        url: "/dashboard-sov",
                        icon: "icon-chart",
                    },
                    {
                        name: "Dashboard",
                        url: "/dashboard-category-india",
                        icon: "icon-speedometer",
                    },
                    {
                        name: "Sentiment",
                        url: "/sentiment-category-india",
                        icon: "icon-chart",
                    },
                    {
                        name: "Price",
                        url: "/price-philips",
                        icon: "icon-chart",
                    },
                    ];
                else
                    items = [{
                        name: "Summary",
                        url: "/sov-dashboard",
                        icon: "icon-chart",
                    },
                    {
                        name: "Dashboard",
                        url: "/dashboard-category",
                        icon: "icon-speedometer",
                    },
                    {
                        name: "Sentiment",
                        url: "/sentiment-category",
                        icon: "icon-chart",
                    },
                        // { name: "Price", url: "/price-hindware", icon: "icon-chart" },
                    ];
            }

            if (userAccess.is_demo) {
                items = [
                    {
                        name: "Reviews and Ratings",
                        icon: "icon-speedometer",
                        submenuItems: [
                            {
                                name: "Brand Reviews",
                                url: "/reviews/brand"
                            },
                            {
                                name: "Category Reviews",
                                url: "/reviews/category"
                            },
                            // {
                            //     name: "Product Reviews",
                            //     url: "/dashboard-category/" + userAccess.client,
                            // },
                            {
                                name: "Product Reviews",
                                url: "/reviews/product"
                            }

                        ]
                    },
                    // { name: "Price", url: "/price/" + userAccess.client, icon: "icon-chart" },
                ];
                if (userAccess.sov_lite) {
                    items.unshift({

name: "Share of Search",
    url: "/share-of-search",
    icon: "icon-chart",
},{
                        name: "Share of Voice",
                        url: "/sov-new",
                        icon: "icon-chart",
                    });
                } else {
                    items.unshift({
                        name: "Share of Voice",
                        url: "/sov/" + userAccess.client,
                        icon: "icon-chart",
                    })
                }
            }
            if (userAccess.is_global_demo) {
                items = [{
                    name: "Share of Voice",
                    url: "/global-sov/" + userAccess.client,
                    icon: "icon-chart",
                },

                {
                    name: "Market Explorer",
                    url: "/global-price/" + userAccess.client,
                    icon: "icon-chart",
                },
                ];
                if (userAccess.client === "global_demo") {
                    items.push({
                        name: "Reviews and Ratings",
                        url: "/global-dashboard-category/" + userAccess.client,
                        icon: "icon-speedometer",
                    }, {
                        name: "Sentiments",
                        url: "/global-sentiments/" + userAccess.client,
                        icon: "icon-chart",
                    }, {
                        name: "Listing Analyser",
                        url: "/lqs-analyser-global",
                        icon: "icon-chart",
                    });
                }
            }
            
            if (userAccess.lqs) {
                items.push({
                    name: "LQS Analyser",
                    url: "/lqs-analyser",
                    icon: "icon-chart",
                });
            }
            if (userAccess.is_rank) {
                items.push({
                    name: "Best Sellers Ranking",
                    url: "/keyword-tracker",
                    icon: "icon-chart",
                });
            }
            
            if (userAccess.amd_india || userAccess.amd_india_oem) {
                items = [{
                    name: "Summary",
                    url: "/sov-summary-amd",
                    icon: "icon-chart",
                },];
            }
            
            if (userAccess.username == "admin") {
                items = [{
                    name: "Admin Home",
                    url: "/admin-dashboard",
                    icon: "icon-chart",
                },
                {
                    name: "Compliance New",
                    url: "/admin-dashboard-new",
                    icon: "icon-chart",
                },
                {
                    name: "Compliance Automation",
                    url: "/compliance-automation",
                    icon: "icon-chart",
                },
                {
                    name: "Spider Monitor",
                    url: "/admin-monitoring",
                    icon: "icon-chart",
                },
                {
                    name: "Spider Management",
                    url: "/admin-spiders-management",
                    icon: "icon-chart",
                },
                {
                    name: "SQL Sync",
                    url: "/sql-sync",
                    icon: "icon-chart",
                },
                {
                    name: "Summary",
                    url: "/sov",
                    icon: "icon-chart",
                },
                {
                    name: "SOV Report",
                    url: "/sov-report",
                    icon: "icon-chart",
                },
                ];
                // items = [
                // { name: 'Non AMD Spiders', url: '/admin-spiders-v2', icon: 'icon-chart' },
                // ]
            }
            if (userAccess.tools) {
                items = [{
                    name: "LQS Analyser",
                    url: "/lqs-analyser",
                    icon: "icon-chart",
                },
                {
                    name: "Best Sellers Ranking",
                    url: "/keyword-tracker",
                    icon: "icon-chart",
                },
                ];
            }

            if (!userAccess.is_demo && userAccess.sov_lite) {
                items.push({
                    name: "Share of Voice",
                    url: "/sov-new",
                    icon: "icon-chart",
                },{

                name: "Share of Search",
                    url: "/share-of-search",
                    icon: "icon-chart",
                }
            );
            }
            if (userAccess.is_price) {
                items.push({
                    name: "Price",
                    url: "/price/" + userAccess.client,
                    icon: "icon-chart",
                });
            }
            if (userAccess.is_pincode) {
                items.push({
                    name: "Availability Tracking",
                    url: "/availability-matrix",
                    icon: "icon-chart",
                });
            }
            if (userAccess.is_price_pin) {
                items.push({
                    name: "Price Tracking",
                    url: "/price-tracking",
                    icon: "icon-chart",
                });
            }
            if (userAccess.buybox) {
                items.push({
                    name: "Buybox Monitor",
                    url: "/buy-box-monitor",
                    icon: "icon-chart",
                });
            }
            if (userAccess.phrase_analyser) {
                items.push({
                    name: "Phrase Analyser",
                    url: "/phrase-analyser",
                    icon: "icon-chart",
                });
            }
            if (userAccess.is_global_price) {
                items.push({
                    name: "Market Explorer",
                    url: "/global-price/" + userAccess.client,
                    icon: "icon-chart",
                });
            }
            
            localStorage.vocSidebar = JSON.stringify(items);
            window.location = "#" + items[0].url;
        },
        plotNavBar() {
            let reviewUserData = JSON.parse(localStorage.reviewUserData);
            let client = reviewUserData.data.client;

            let navBarMapper = {
                summary: {
                    name: "Summary",
                    url: "/sov",
                    icon: "icon-chart",
                },
                Share_Of_Voice: {
                    name: "Share of Voice",
                    url: "/sov-new",
                    icon: "icon-chart",
                },
                Share_Of_Search: {
                    name: "Share of Search",
                    url: "/share-of-search",
                    icon: "icon-chart",
                },
                Reviews_And_Ratings: {
                        name: "Reviews and Ratings",
                        icon: "icon-speedometer",
                        submenuItems: [
                            {
                                name: "Brand Reviews",
                                url: "/reviews/brand"
                            },
                            {
                                name: "Category Reviews",
                                url: "/reviews/category"
                            },
                            {
                                name: "Product Reviews",
                                url: "/reviews/product"
                            }
                        ]
                    },
                Sentiments: {
                    name: "Sentiments",
                    url: "/sentiments/" + client.replaceAll(" ", "_"),
                    icon: "icon-chart",
                },
                sov_report: {
                    name: "SOV Report",
                    url: "/sov-report",
                    icon: "icon-chart",
                },
                admin_dashboard: {
                    name: "Admin Home",
                    url: "/admin-dashboard",
                    icon: "icon-chart",
                },
                compliance_new: {
                    name: "Compliance New",
                    url: "/admin-dashboard-new",
                    icon: "icon-chart",
                },
                compliance_automation: {
                    name: "Compliance Automation",
                    url: "/compliance-automation",
                    icon: "icon-chart",
                },
                admin_monitoring: {
                    name: "Spider Monitor",
                    url: "/admin-monitoring",
                    icon: "icon-chart",
                },
                admin_spider_management: {
                    name: "Spider Management",
                    url: "/admin-spiders-management",
                    icon: "icon-chart",
                },
                sql_sync: {
                    name: "SQL Sync",
                    url: "/sql-sync",
                    icon: "icon-chart",
                },
                Listing_Quality_Score: {
                    name: "LQS Analyser",
                    url: "/lqs-analyser",
                    icon: "icon-chart",
                },
                Rank_Tracker: {
                    name: "Best Sellers Ranking",
                    url: "/keyword-tracker",
                    icon: "icon-chart",
                },
                Price_Tracking: {
                    name: "Price Tracking",
                    url: "/price-tracking",
                    icon: "icon-chart",
                },
                no_pin_price_tracking: {
                    name: "Price",
                    url: "/price/" + client.replaceAll(" ", "_"),
                    icon: "icon-chart",
                },
                Availability_Tracking: {
                    name: "Availability Tracking",
                    url: "/availability-matrix",
                    icon: "icon-chart",
                },
                Buy_Box_Monitor: {
                    name: "Buybox Monitor",
                    url: "/buy-box-monitor",
                    icon: "icon-chart",
                },
                Phrase_Analyser: {
                    name: "Phrase Analyser",
                    url: "/phrase-analyser",
                    icon: "icon-chart",
                },
                Market_Explorer: {
                    name: "Market Explorer",
                    url: "/global-price/" + client.replaceAll(" ", "_"),
                    icon: "icon-chart",
                }
            }

            let items = [];

            if (!reviewUserData.userRegister) {
                items = [{
                    name: "Form",
                    url: "/demo-form",
                    icon: "icon-chart"
                }]
            } else {
                reviewUserData.data.nav_menu.forEach(nav => {
                    items.push(navBarMapper[nav])
                })
            }
            localStorage.vocSidebar = JSON.stringify(items);
            window.location = "#" + items[0].url;
        },
        login() {
            let url = "/api/sense_user/login";
            if (!this.username) {
                this.flagError = true;
                return false;
            }
            this.$http
                .post(url, {
                    email_address: this.username,
                    password: this.password,
                })
                .then(
                    (response) => {
                        response.body.data.nav_menu.splice(1, 0, "Share_Of_Search")

                        localStorage.setItem(
                            "reviewUserData",
                            JSON.stringify(response.body)
                        );

                        this.userAccess = response.body.data;

                        if (!response.body.userRegister) {
                            if(this.userAccess.client !== 'amd') {
                                this.plotNavBar();
                            } else this.processRedirect(this.userAccess);
                        } else {    
                            this.plotNavBar()
                            this.processUserData(response.body);
                        }
                    },
                    (err) => {
                        this.flagError = true;
                        console.log(err.body.summary);
                        console.log("login error");
                    }
                );
        },
        processUserData(userData) {
            let self = this;
            let nonPrimaryProductOptions = [];
            let primaryProductOptions = [];
            let forumProducts = [];
            for (let [idx, dataset] of userData.products.entries()) {
                if (dataset.primary) {
                    primaryProductOptions.push(dataset);
                } else {
                    nonPrimaryProductOptions.push(dataset);
                }
                if (dataset.forum) {
                    forumProducts.push(dataset);
                }
            }
            let products = [];
            let selectedProducts = [];
            for (let [idx, dataset] of userData.products.entries()) {
                if (dataset.primary) {
                    products.push(dataset);
                    selectedProducts.push(dataset.product_name);
                    break;
                }
            }
            for (let [idx, dataset] of userData.products.entries()) {
                if (products.length < 3) {
                    if (!dataset.primary) {
                        products.push(dataset);
                        selectedProducts.push(dataset.product_name);
                    }
                } else {
                    break;
                }
            }

            let reviewCustomData = {
                primaryProductOptions: primaryProductOptions,
                nonPrimaryProductOptions: nonPrimaryProductOptions,
                products: products,
                selectedProducts: selectedProducts,
            };
            if (userData.data.show_forum) {
                reviewCustomData.forumProducts = forumProducts;
            }
            localStorage.setItem(
                "reviewCustomData",
                JSON.stringify(reviewCustomData)
            );
        },
    },
};
</script>
<style scoped>
.loginPageContainer {
    background-color: #fff;
}

.mainHeading {
    color: #000;
    font-size: 1.4rem;
    font-weight: bold;
}

.subHeading {
    font-size: .8rem;
    color: #5B5B5B;
}

.redirect {
    font-size: 16px;
    color: #5B5B5B;
}

.redirect span {
    color: var(--primary_brand) !important;
    cursor: pointer !important;
    font-weight: 600;
}

.weavrLogoContainer {
    height: 45px;
    padding: 0rem 1rem;
    margin-left: .5rem;
}

.app .weavr-logo img {
    height: 100%;
}

.container-fluid {
    height: 90vh !important;
    padding: 0 !important;
}

.hero-login-section {
    width: 100%;
    height: 100% !important;
}

.login-page-img {
    width: 98%;
}

input:-webkit-autofill {
    background-color: red !important;
}


.left-img,
.right-form {
    padding: 0 !important;

}

/* .right-form {
    display: flex;
    align-items: center;
    margin-top: -80px;
} */

a {
    color: inherit;
}

a:hover {
    text-decoration: none;
    color: var(--primary_brand);
}

.login-form {
    width: 80%;
    margin: 0 auto;
}

.login-heading {
    margin-bottom: 1rem;
    color: #fff;
    font-size: 1.2rem;
    text-align: left;
}

.input-group {
    position: relative;
    margin-bottom: 1.3rem;
}

.input-group label {
    position: absolute;
    top: -7px;
    left: 35px;
    color: var(--primary_brand);
    background: #fff;
    padding: 0 15px;
    z-index: 9999;
}

.input-group input {
    padding: .8rem;
    border: .08rem solid var(--primary_brand);
    width: 100%;
    height: 100%;
    background: #fff !important;
    outline: none !important;
    border-radius: 7px;
}

.input-group input:focus {
    border: .1rem solid var(--primary_brand) !important;
    outline: none !important;
    box-shadow: 0 0 5px 1px #bcd1d2 !important;
}

.form-control::placeholder {
    color: #919191 !important;
    font-family: "poppins" !important;
    padding: 1.375rem 0.75rem !important;
    font-size: 0.9rem !important;
}

.danger {
    border-color: var(--red) !important;
    color: var(--red) !important;
}

.flagError {
    position: absolute;
    bottom: -30px;
}

.remember-forgot-section {
    display: flex;
    justify-content: space-between;
    color: var(--primary_brand);
    margin-top: 2rem;
}

.remember-forgot-section a {
    color: var(--primary_brand);
}

.remember-forgot-section label {
    margin-left: 0.5rem;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 1rem;
    border-radius: 10px;
    border: none;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 17px;
    width: 100%;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

button:focus {
    box-shadow: none !important;
    outline: none !important;
    background: var(--primary_brand);
}

.logoSection {
    padding: 20px 0px;
}

@media only screen and (min-width: 768px) {

    /* Styles for medium devices */
    .login-page-img {
        width: 92%;
    }

    .right-form {
        display: block !important;
        align-items: start !important;
        margin-top: 30px;
    }

    button.primarycolor {
        padding: .7rem 1.3rem !important;
    }
}

@media only screen and (min-width: 992px) {

    /* Styles for large devices */
    .login-page-img {
        width: 100%;
        margin-top: 0vh;
    }

    .right-form {
        display: flex !important;
        align-items: start !important;
        margin-top: 3vh;
    }

    button.primarycolor {
        padding: .8rem 1.3rem !important;
    }

}

@media only screen and (min-width: 1200px) {

    /* Styles for extra large devices */
    .login-page-img {
        width: 75%;
        margin-top: 0vh;
    }

    .right-form {
        display: flex !important;
        align-items: center !important;
        margin-top: -80px;
    }

    button.primarycolor {
        padding: .9rem 1.3rem !important;
    }
}

@media only screen and (min-width: 1350px) {

    /* Styles for extra large devices */
    .login-page-img {
        width: 100%;
        margin-top: 0vh;
    }

}

@media only screen and (min-width: 1400px) {

    /* Styles for extra extra large devices */
    .login-page-img {
        width: 88%;
        margin-top: 0vh;
    }

    .right-form {
        display: flex !important;
        align-items: center !important;
        margin-top: -120px;
    }

    button.primarycolor {
        padding: .9rem 1.3rem !important;
    }
}

@media only screen and (min-width: 1600px) {

    /* Styles for extra extra large devices */
    .login-page-img {
        width: 100%;
        margin-top: 5vh;
    }

    .right-form {
        display: flex !important;
        align-items: center !important;
        margin-top: -120px;
    }

    button.primarycolor {
        padding: .9rem 1.3rem !important;
    }
}

@media only screen and (min-width: 1850px) {

    /* Styles for extra extra large devices */
    .login-page-img {
        width: 85%;
        margin-top: 0vh;
    }

    .right-form {
        display: flex !important;
        align-items: center !important;
        margin-top: -120px;
    }

    button.primarycolor {
        padding: .9rem 1.3rem !important;
    }
}
</style>
<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.app {
    font-family: "poppins";
}

:root {
    --weavr-color: #065559;
}

.app {
    height: 100vh;
    width: 100%;
}
</style>